/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Joinorganizationdescription2Inputs */

const zh_learn_joinorganizationdescription2 = /** @type {(inputs: Learn_Joinorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分享内容仅对组织成员开放。加入后即可开始学习。`)
};

const en_learn_joinorganizationdescription2 = /** @type {(inputs: Learn_Joinorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This shared session is limited to organization members. Join first, then start learning.`)
};

const es_learn_joinorganizationdescription2 = /** @type {(inputs: Learn_Joinorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta sesión compartida está limitada a miembros de la organización. Únete primero y luego empieza a estudiar.`)
};

/**
* | output |
* | --- |
* | "This shared session is limited to organization members. Join first, then start learning." |
*
* @param {Learn_Joinorganizationdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_joinorganizationdescription2 = /** @type {((inputs?: Learn_Joinorganizationdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Joinorganizationdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_joinorganizationdescription2(inputs)
	if (locale === "en") return en_learn_joinorganizationdescription2(inputs)
	return es_learn_joinorganizationdescription2(inputs)
});
export { learn_joinorganizationdescription2 as "learn_joinOrganizationDescription" }